import { Nullable } from "@brg/api"

export enum FOLDERS_MODE {
    edit = 'edit',
    hide = 'hide',
    delete = 'delete',
}

export type FolderT = {
    accountId?: string,
    description: string
    entityIds?: string[],
    entityType?: string,
    id?: string,
    isAvailableAtLink?: boolean | string,
    isDefault?: boolean,
    isHidden?: boolean,
    name: string
    parentFolderIds?: string[]
    position?: any
}

export type FolderEditT = Pick<FolderT, 'id' | 'entityIds'>import { Nullable } from "@brg/api"

export enum FOLDERS_MODE {
    edit = 'edit',
    hide = 'hide',
    delete = 'delete',
}

export type FolderT = {
    accountId?: string,
    description: string
    entityIds?: string[],
    entityType?: string,
    id?: string,
    isAvailableAtLink?: boolean | string,
    isDefault?: boolean,
    isHidden?: boolean,
    name: string
    parentFolderIds?: string[]
    position?: any
}

export type FolderEditT = Pick<FolderT, 'id' | 'entityIds'>